import { boolean, object, optional } from 'superstruct';
import { email, phoneNumber, userString } from '@arc/shared/util-superstruct';
export const DUPLICATE_USER_EMAIL = 'validations:Duplicate User Email';
export const AddUserDto = object({
  name: userString('validations:Required'),
  email: email(),
  phone: optional(phoneNumber()),
  superuser: optional(boolean()),
  archived: optional(boolean()),
  sendWelcomeEmail: optional(boolean())
});